import { alpha, Theme } from '@mui/material/styles';

export default function ToggleButton(theme: Theme) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          border: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.secondary,
          transition: theme.transitions.create(['background-color', 'border-color', 'color']),
          '&:hover': {
            backgroundColor: alpha(theme.palette.accent.main, 0.06),
            borderColor: alpha(theme.palette.accent.main, 0.4),
          },
          '&.Mui-selected': {
            color: theme.palette.accent.main,
            backgroundColor: alpha(theme.palette.accent.main, 0.16),
            borderColor: alpha(theme.palette.accent.main, 0.5),
            '&:hover': {
              backgroundColor: alpha(theme.palette.accent.main, 0.24),
            },
          },
          '&.Mui-disabled': {
            color: theme.palette.text.disabled,
            borderColor: theme.palette.divider,
          },
        },
      },
    },
  };
}
